<template>
    <span>
        <pazar12-modules></pazar12-modules>
        <page-footer></page-footer>
    </span>
</template>
<script>
import Pazar12Modules from '@/components/Pazar12Modules';
import PageFooter from '@/components/PageFooter';
export default {
    name: 'modules12',
    components: {
        Pazar12Modules,
        PageFooter
    }
};
</script>


